// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import filter from '@/filter/filter'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
import httpRequest from '@/server/http-api'
import Vuex from 'vuex'
import $ from 'jquery'



import permission from '@/utils/permission'

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

window.jQuery = $;
window.$ = $;

import '@/../static/css/reset.css'        /*引入公共样式-重置文件*/
import '@/../static/css/global.css'       /*引入公共样式-全局样式*/
import '@/../static/css/texthtml.css'       /*引入公共样式-富文本重置样式*/

import {Message,MessageBox,Loading} from 'element-ui'

Vue.config.productionTip = false
Vue.prototype.$client = httpRequest
Vue.prototype.$store = store
Vue.prototype.$elementMsg = Message
Vue.prototype.$elementMsgBox = MessageBox
Vue.prototype.$elementLoading = Loading

Vue.use(ElementUI)
Vue.use(Vuex)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js